<template>
  <AppTable
    :table-data="tableData"
    :loading="loading"
    :lazy-loading="lazyLoading"
    class="widget-common"
    @sort="sort"
  >
    <AppTableColumn
      v-slot="{ row }"
      header="Member"
      name="full_name"
      :sort-by="buildSortOptions('full_name')"
    >
      <div class="d-flex">
        <AppAvatar
          size="speck"
          :avatar="row.avatar"
        />
        <div class="ellipsis">{{ row.full_name }}</div>
      </div>
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Merged PRs"
      name="prs"
      :sort-by="buildSortOptions('prs')"
    >
      <div class="d-flex">
        <span class="mr-5">{{ row.prs }}</span>
        <InsightsMetric
          v-show="showMetrics"
          type="number"
          :value="row.prs_delta"
        />
      </div>
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Reviews"
      name="reviews"
      :sort-by="buildSortOptions('reviews')"
    >
      <div class="d-flex">
        <span class="mr-5">{{ row.reviews }}</span>
        <InsightsMetric
          v-show="showMetrics"
          type="number"
          :value="row.reviews_delta"
        />
      </div>
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Comments"
      name="comments"
      :sort-by="buildSortOptions('comments')"
    >
      <div class="d-flex">
        <span class="mr-5">{{ row.comments }}</span>
        <InsightsMetric
          v-show="showMetrics"
          type="number"
          :value="row.comments_delta"
        />
      </div>
    </AppTableColumn>
  </AppTable>
</template>

<script>
import InsightsMetric from '~/components/insights/InsightsMetric.vue';

export default {
  components: {
    InsightsMetric,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    showMetrics: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    lazyLoading: {
      type: Boolean,
      default: false,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sort(options) {
      this.$emit('sort', options);
    },
    buildSortOptions(field) {
      return {
        field,
        direction: this.sortOptions.field === field ? this.sortOptions.direction : null,
      };
    },
  },
};
</script>
